import { useMutation, useQuery } from "react-query"
import { Notification } from "../api/notification"
import { TChannel } from "../shared/types/Channel.type"
import { useState } from "react"
import { get } from "lodash"
import { TSchedule } from "../shared/types/schedule.type"
import { daDK } from "@mui/x-date-pickers"
import { GallopData } from "../api/gallopData"
import { hydraTransform } from "../shared/utils/hydraTransformer"
import { Stable } from "../api/Stable"

export const useNotificationsSettings = (enableQuery = false, trainer?: string) => {

    //Mutations
    const saveChannelMutation = useMutation((data: Partial<TChannel>) => Notification.saveChannel(data))
    const saveWhatsappChannelMutation = useMutation((data: Partial<TChannel>) => Notification.saveWhatsappChannel(data))
    const saveConfigMutation = useMutation((data: Partial<TSchedule>) => Notification.saveConfig(data))
    const saveSableMutation = useMutation((data: Partial<TSchedule>) => Stable.saveStable(data))
    const deleteChannelMutation = useMutation((id: number) => Notification.deleteChannel(id))
    const deleteWhatsappChannelMutation = useMutation((id: number) => Notification.deleteWhatsappChannel(id))
    const deleteWhatsappGroupChannelMutation = useMutation((id: number) => Notification.deleteWhatsappGroupChannel(id))
    const deleteConfigMutation = useMutation((id: number) => Notification.deleteConfig(id))
    const deleteStableMutation = useMutation((id: number) => Stable.deleteStable(id))
    const updateConfigMutation = useMutation(({ id, config }: { id: number, config: Partial<TSchedule> }) => Notification.updateConfig(id, config))
    const updateStableMutation = useMutation(({ id, config }: { id: number, config: Partial<TSchedule> }) => Stable.updateStable(id, config))
    const updateChannelMutation = useMutation(({ id, channel }: { id: number, channel: Pick<TChannel, 'lang' | 'name' | 'unit_system' | 'speed_unit' | 'targets' | 'user'> }) => Notification.updateChannel(id, channel))
    const updateWhatsappChannelMutation = useMutation(({ id, channel }: { id: number, channel: Pick<TChannel, 'lang' | 'name' | 'unit_system' | 'speed_unit' | 'targets' | 'user'> }) => Notification.updateWhatsappChannel(id, channel))
    const generateSchedulePhraseMutation = useMutation((data: Partial<TSchedule>) => Notification.generatePhrase(data))
    
    
    const triggerTrainingSend = useMutation(({ id, dates }: {
        id: number, dates: {
            start_date: string,
            end_date: string
        }
    }) => Notification.triggerTraining(id, dates))
    
    
    const triggerGallopSend = useMutation(({ id, dates }: {
        id: number, dates: {
            start_date: string,
            end_date: string
        }
    }) => Notification.triggerGallop(id, dates))
    
    const triggerStableSend = useMutation(({ id, dates }: {
        id: number, dates: {
            start_date: string,
            end_date: string
        }
    }) => Stable.triggerStable(id, dates))
    
    //query
    const query = useQuery(['channels'], () => Notification.getChannels(trainer), {
        refetchOnWindowFocus: false,
        enabled: enableQuery,

    })

    const queryConfig = useQuery(['configs'], () => Notification.getConfigs(trainer), {
        refetchOnWindowFocus: false,
        enabled: enableQuery,

    })

    const gallopsConfig = useQuery(['gallops'], () => GallopData.getGallops(trainer), {
        refetchOnWindowFocus: false,
        cacheTime: 900000,
        enabled: enableQuery
    })

    const stableConfig = useQuery(['stables'], () => Stable.getStableRepports(trainer), {
        refetchOnWindowFocus: false,
        cacheTime: 900000,
        enabled: enableQuery
    })

    return {
        saveChannel: saveChannelMutation,
        saveConfig: saveConfigMutation,
        saveStable: saveSableMutation,
        saveWhatsappChannel: saveWhatsappChannelMutation,
        updateWhatsappChannel: updateWhatsappChannelMutation,
        channels: hydraTransform(query.data?.data ?? []),
        configs: hydraTransform(queryConfig.data?.data ?? []),
        gallops: hydraTransform(gallopsConfig.data?.data ?? []),
        stables: hydraTransform(stableConfig.data?.data ?? []),
        deleteConfig: deleteConfigMutation,
        deleteStable: deleteStableMutation,
        deleteChannel: deleteChannelMutation,
        deleteWhatsappChannel: deleteWhatsappChannelMutation,
        deleteWhatsappGroupChannel: deleteWhatsappGroupChannelMutation,
        updateConfig: updateConfigMutation,
        updateStable: updateStableMutation,
        updateChannel: updateChannelMutation,
        channelsLoading: query.isLoading || query.isFetching,
        configsLoading: queryConfig.isLoading || queryConfig.isFetching,
        generatePhrase: generateSchedulePhraseMutation,
        triggerTrainingSend,
        triggerGallopSend,
        triggerStableSend,

    }
}